/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/24/19
 * Time: 10:16 AM
 */
import React, {Component} from 'react';
import './FloorUpdate.css';
import {Button, Col, Row} from "reactstrap";
import TxtInput from "../../../../../components/Input/Input/TxtLbl";
import {Tooltip} from "antd";
import {Button as SementicBtn, Checkbox, Form, Icon} from "semantic-ui-react";
import Download from "../../../../../components/Button/DownloadbleButton";
import {MDBDataTable} from "mdbreact";
import Modal from "../../../../../components/Modal/Modal";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import {SketchPicker} from "react-color";
import LabelInput from "../../../../../components/Input/LabelInput/LabelInput";
import * as common from "../../../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import Cookies from "js-cookie";
import axiosTags from "../../../../../axios/axios_tag";
import apiConfig from "../../../../../axios/axios_api_services";
import * as validator from "../../../../../util/Validator";

class App extends Component {
  state = {
    updateFloor: false,

    description: '',
    floorColour: '#ffffff',
    floor_id: 0,
    level: '',
    status: true,

    floors_list: []
  };

  clearFields = () => {
    this.setState({
      description: '',
      floorColour: '#ffffff',
      floor_id: 0,
      level: '',
      status: true,
      updateFloor: false,
    })
  };

  updateFloor = (obj) => {
    this.setState({
      updateFloor: true,
      description: obj.description,
      floorColour: obj.floorColour,
      floor_id: obj.floor_id,
      level: obj.level,
      status: obj.status === "AVAILABLE",
    });
    document.querySelector(".floor-update-wrapper").scrollIntoView();
  };

  deleteFloor_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.delete(apiConfig.CORPOARTE_FLOOR_DELETE(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Floor details successfully deleted", 0);

          this.props.closeModal("floor_modal", false);
          this.props.refreshData();

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteFloor_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  deleteFloor = (id, name) => {
    swal({
      title: "Do you want to delete this floor? First please enter \"" + name + "\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if (value === name) {
          this.deleteFloor_(id)
        } else {
          common.warningAlert("Can't delete floor", 1)
        }
      });
  };
  handleChange = name => event => {
    let value = event.target.value;
    if (name === "level") {
      let isValid = validator.isOnlyNumbersValdator(value);
      if (!isValid && value !== "") return;
    }

    this.setState({
      [name]: value
    });
  };
  handleChangeComplete = (color) => {
    this.setState({floorColour: color.hex});
  };
  submit = () => {

    if (this.state.description.trim() === "" || this.state.level === "") {
      common.notifyMessage("Please enter all required fields")
    } else {
      const obj = {
        description: this.state.description.trim(),
        floorColour: this.state.floorColour,
        floor_id: this.state.floor_id,
        level: this.state.level,
        status: this.state.status ? "AVAILABLE" : "UNAVAILABLE"
      };

      swal({
        title: this.state.updateFloor ? "Are you sure do you want to update floor?" : "Are you sure do you want to add floor?",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {

        switch (value) {
          case "action":
            this.sendToBackend(obj);
            break;
        }
      });
    }
  };

  updateFloor_ = (obj) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);

    axiosTags.post(apiConfig.CORPORATES_FLOOR, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert(response.data.message, 0);
          this.props.closeModal("floor_modal", false);
          this.props.refreshData();

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.updateFloor_(obj)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  newFloor_ = () => {

    const obj = {
      description: this.state.description.trim(),
      floorColour: this.state.floorColour,
      level: this.state.level.trim(),
      status: this.state.status ? "AVAILABLE" : "UNAVAILABLE"
    };
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);

    axiosTags.put(apiConfig.CORPOARTE_FLOOR_CREATE({
      corporateId: this.props.usr_obj.corporateId,
      buildingId: this.props.buildingId
    }), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert(response.data.message, 0);
          this.props.closeModal("floor_modal", false);
          this.props.refreshData();

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.newFloor_(obj)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  sendToBackend = (obj) => {
    if (this.state.updateFloor) {
      //update
      this.updateFloor_(obj);
    } else {
      //add new
      this.newFloor_();
    }
  };

  componentDidMount() {
    this.setState({
      floors_list: this.props.floors_list
    })
  }

  render() {
    let rows = [];
    let floor_list = this.state.floors_list;
    if (floor_list.length !== 0) {
      floor_list.map((floor, index) => {
        const obj = {
          desc: floor.description,
          level: floor.level,
          status: floor.status,
          color: floor.floorColour,
          action: <div>
            <SementicBtn circular icon='edit' onClick={() => this.updateFloor(floor)}/>
            {this.state.floors_list.length > 1 ?
              <SementicBtn className="cus-btn" circular icon='trash alternate'
                           onClick={() => this.deleteFloor(floor.floor_id, floor.description)}/> : null}
          </div>,
        };
        rows.push(obj)
      })
    }

    let columns = this.props.table_data.columns;
    let table_data = {columns, rows};

    return (
      <Modal isOpen={true} toggle={() => this.props.closeModal("floor_modal", false)} size="lg" className={"floor-update-wrapper"}
             header="View All Floors">

        <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
          <Row>
            <Col lg={6}>
              <Form>
                <Form.Group widths='equal'>
                  <LabelInput
                    required
                    tagText={"Floor Name"}
                    placeholder={"Floor Name"}
                    value={this.state.description}
                    onChange={this.handleChange('description')}
                  />
                </Form.Group>

                <Col className="marginTop" xs={12} sm={12} md={12} lg={12}>
                  <center>
                    <SketchPicker
                      color={this.state.floorColour}
                      onChangeComplete={this.handleChangeComplete}
                    />
                  </center>
                </Col>


              </Form>
            </Col>
            <Col lg={6}>
              <Form>
                <Form.Group widths='equal'>
                  <LabelInput
                    required
                    tagText={"Level"}
                    placeholder={"Floor Level"}
                    value={this.state.level}
                    onChange={this.handleChange('level')}
                  />
                </Form.Group>
              </Form>

              <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                        checked={this.state.status} onChange={() => this.setState({status: !this.state.status})} toggle
                        label={this.state.status ? 'Available Floor' : 'Unavailable Floor'}/>

              <Row>
                <Col className="marginTop" xs={12} sm={12} md={12} lg={12}>
                  <center>
                    <Button
                      className="submit-btn"
                      onClick={this.submit}
                    >{this.state.updateFloor ? "Update Floor" : "Add Floor"}</Button>
                    &nbsp;&nbsp;
                    <Tooltip placement="topLeft" title="Clear input fields">
                      <SementicBtn circular icon='refresh' onClick={this.clearFields}/>
                    </Tooltip>

                  </center>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
          <Row>
            <Col lg={12}>
              <Download data={this.state.floors_list}/>

              <MDBDataTable
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                data={table_data}
              />

            </Col>
          </Row>
        </Col>

      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  table_data: state.COPLocationReducer.table_data,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addFloor: (data) => dispatch(actionCreator.addFloor(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
